import store from '@/store'
import { AUTH_LOGOUT } from '@/store/actions/auth'
import axios from 'axios'

const studentData = [
  {
    id: '1',
    student: {
      id: '1',
      name: 'Borja Presente',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '2',
    student: {
      id: '2',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '3',
    student: {
      id: '3',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '4',
    student: {
      id: '4',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '5',
    student: {
      id: '5',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '6',
    student: {
      id: '6',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '7',
    student: {
      id: '7',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '8',
    student: {
      id: '8',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '9',
    student: {
      id: '9',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '10',
    student: {
      id: '10',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '11',
    student: {
      id: '11',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '12',
    student: {
      id: '12',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '13',
    student: {
      id: '13',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '14',
    student: {
      id: '14',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '15',
    student: {
      id: '15',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '16',
    student: {
      id: '16',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  },
  {
    id: '17',
    student: {
      id: '17',
      name: 'Nombre Completo Test',
      assistence: 'TRUE',
      breakfast: 'Todo',
      firstCourseType: 'Puré',
      firstCourseValue: 'Todo',
      secondCourse: 'Todo',
      dessertType: 'Fruta',
      dessertValue: 'Todo',
      snack: 'Todo',
      nap: 'NO',
      deposition: '0',
      behaviour: 'Limpio'
    },
    menu: {
      firstCourse: 'Crema de espinacas',
      secondCourse:
        'Arroz a la marinera con abadejo, guisantes, zanahoria y pimiento rojo',
      dessert: 'Fruta',
      suggestedDinner: 'Ensalada. Carne. Fruta',
      nextMenu:
        'Próximo menú: 14/04/2021\nPotaje de verduras con batata amarilla y gofio\nTortilla española con cebolla, pimiento y ensalada verde con aguacate y salsa casera de tomate canario\nLácteo\n'
    }
  }
]
const classroomList = [
  {id: '4aA', name: 'Cuarto Primaria A', center: 'a', tutor: 'yolanda'},
  {id: '4aB', name: 'Cuarto Primaria B', center: 'b', tutor: 'ramon'},
  {id: '4aC', name: 'Cuarto Primaria C', center: 'c', tutor: 'margarita'},
  {id: '4aD', name: 'Cuarto Primaria D', center: 'd', tutor: 'josefa'}
]

const mocks = {
  '/api/auth/login': { POST: {data: { token: 'This-is-a-mocked-token' }} },
  '/api/agendadiaria/currentDiary': {GET: { diaryDate: '2021-04-28' }},
  auth: { POST: { token: 'This-is-a-mocked-token' } },
  '/api/agendadiaria/user': { GET: { name: 'doggo', title: 'sir' } },
  '/getDiary': {
    GET: studentData
  },
  '/publish': {
    POST: { status: 'success' }
  },
  '/api/agendadiaria/classrooms': {
  // 'agenda/current/2': {
    POST: { status: 'success' },
    GET: classroomList
  }
}

export const apiFakeCall = ({ url, method = 'GET', data = {}, extraHeader = {} }) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(mocks[url][method || 'GET'])
        console.log(`Mocked '${url}' - ${method || 'GET'}`)
        console.log('response: ', mocks[url][method || 'GET'])
      } catch (err) {
        reject(new Error(err))
      }
    }, 1000)
  })

export const apiFakeAuthCall = ({ url, method = 'GET', data = {}, extraHeader = {} }) => apiCall({ url, method })

export const apiAuthCallReal = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  const headerByDefault = { 'Authorization': 'Bearer ' + store.getters.getToken }
  const headers = { ...headerByDefault, ...extraHeader }
  // console.log({headers})
  return new Promise((resolve, reject) => {
    apiCall({url, method, data, extraHeader: headers}).then(resp => {
      console.log({apiAuthCall: resp})
      resolve(resp)
    })
      .catch(error => {
        console.log({apiAuthCall: error})
        if (error.response && error.response.status === 401) store.dispatch(AUTH_LOGOUT)
        reject(error)
      })
  })
}

export const apiCallReal = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  const headerByDefault = { 'Content-Type': 'application/json' }
  const headers = { ...headerByDefault, ...extraHeader }
  const endpoint = process.env.API_URL + url

  return new Promise((resolve, reject) => {
    axios({ url: endpoint, data, method, headers })
      .then(resp => {
        // console.log({apiCall: resp})
        resolve(resp.data)
      })
      .catch(error => {
        console.log({apiCallError: error})
        reject(error)
      })
  })
}

export const getResource = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  const headerByDefault = { 'Content-Type': 'application/json' }
  const headers = { ...headerByDefault, ...extraHeader }
  return new Promise((resolve, reject) => {
    axios({ url, data, method, headers })
      .then(resp => {
        // console.log({apiCall: resp})
        resolve(resp.data)
      })
      .catch(error => {
        console.log({apiCallError: error})
        reject(error)
      })
  })
}

export const apiCall = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  return process.env.API_TEST ? apiFakeCall({ url, method, data, extraHeader }) : apiCallReal({ url, method, data, extraHeader })
}

export const apiAuthCall = ({ url, method = 'GET', data = {}, extraHeader = {} }) => {
  return process.env.API_TEST ? apiFakeAuthCall({ url, method, data, extraHeader }) : apiAuthCallReal({ url, method, data, extraHeader })
}

export default {apiCall, apiAuthCall}



// WEBPACK FOOTER //
// ./src/utils/api.js